// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1JIGp","header":"PatientQuestionnaire_header__2DTNr","info":"PatientQuestionnaire_info__3XdzU"};